import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-24 pb-20 px-4 md:px-8 overflow-hidden bg-nightBlue" data-id="element-61">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-62" />

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-63">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="font-playfair font-bold text-4xl md:text-5xl lg:text-6xl text-warmWhite leading-tight mb-6" data-id="element-64">
          El Protocolo de Sincronización Biológica:{' '}
          <br className="hidden md:block" data-id="element-65" />
          <span className="text-gold" data-id="element-66">
            Cómo Recuperar el Sueño Profundo después de los 50 (Sin una Sola
            Pastilla)
          </span>
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="font-montserrat font-semibold text-lg md:text-xl text-warmWhite/90 max-w-3xl mx-auto mb-12 leading-relaxed" data-id="element-67">
          La guía definitiva para apagar la "mente que no calla" y despertar
          cada mañana con energía real, sin la resaca química de los somníferos.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="mb-12 relative max-w-4xl mx-auto" data-id="element-68">
          <div className="absolute inset-0 bg-gradient-to-t from-nightBlue via-transparent to-transparent z-10" data-id="element-69" />
          <img src="https://cdn.magicpatterns.com/uploads/rJEd4GWv1b7JPNkHBwNR88/SUENO_PROFUNDO_2.png" alt="Sueño Profundo (Sin Pastillas) - Mockup del producto" className="w-full h-auto rounded-2xl shadow-2xl object-cover border border-white/5" data-id="element-70" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-71">
          <CTAButton data-id="element-72">SÍ, QUIERO VOLVER A DORMIR PROFUNDAMENTE</CTAButton>
        </motion.div>
      </div>
    </section>;
}